import { Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import {
  AccountListBellConfiguration,
  AccountOwners,
} from '../omega-timestamp-status-bar.model'
import { ConfigureBellModalComponent } from './configure-bell-modal.component'

@Injectable({
  providedIn: 'root',
})
export class ConfigureBellModalService {
  constructor(
    private readonly modalService: NgbModal,
    readonly modalPositionService: ModalPositionService,
  ) {}

  toggleConfigureBellModal(
    currentConfig: AccountListBellConfiguration,
    accountOwners: AccountOwners,
  ): Promise<AccountListBellConfiguration | undefined> {
    const compKey = 'configure-bell'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(ConfigureBellModalComponent, {
      keyboard: false,
      windowClass: uniqueId,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    })
    const component = modalRef.componentInstance as ConfigureBellModalComponent

    component.init(
      accountOwners,
      currentConfig.accountOwnerField,
      currentConfig.userNames,
    )
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
    return modalRef.result.then(
      response => response,
      () => {},
    )
  }
}
